import { render, staticRenderFns } from "./config-sms.vue?vue&type=template&id=0d224811&"
import script from "./config-sms.vue?vue&type=script&lang=js&"
export * from "./config-sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports